// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"d5325470","208":"57739263","318":"cb38d330","453":"7f299b23","723":"929506bc","937":"91efba64"}[chunkId] + ".chunk.css";
};